import { Button, useNotify, useRefresh } from "react-admin";
import ClearIcon from "@mui/icons-material/Clear";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";

const RemoveDocumentTypeDialog = ({ campaignId, documentTypeId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      doctoralRequests.removeCampaignDocumentType(campaignId, documentTypeId),
      null,
      "DELETE",
    );
    notify("Документът е премахнат успешно", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Премахни документ от кампанията"
      message="Сигурни ли сте, че искате да премахнете този документ от кампанията?"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label=""
          startIcon={<ClearIcon />}
          variant="text"
          color="error"
        />
      }
    />
  );
};

export default RemoveDocumentTypeDialog;
